import { createSelector } from "@reduxjs/toolkit";
import { helpers } from "../../../packages/helpers";
import type { AppState } from "../../../store";

const { getStringValue } = helpers.text;

export const selectChatId = createSelector(
  (state: AppState) => state.chat.id,
  (chatId) => getStringValue(chatId)
);
